import React,{useState} from "react";
import Header from "../Components/Header";
import { Link,useNavigate } from "react-router-dom";
import axios from "axios";

const AddAgent = () => {
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const [formData, setFormData] = useState({
       /*  type_of_category: "", */
        agent_name: "",
      });
    
      const [loading, setLoading] = useState(false); // Loader state
      const [message, setMessage] = useState(""); // Success/Error message
    
      // Handle input changes
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
      // Handle form submission
      const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
      
        try {
          const response = await axios.post(`${API_BASE_URL}agent_add.php`, formData);
          
          console.log("API Response:", response.data); // Debugging: Log the full response
      
          // Check if response.data exists and has the expected structure
          if (response.data && response.data.head && response.data.head.code === 200) {
            setMessage("agent added successfully!");
            setFormData({ type_of_agent: "", agent_name: "" }); // Reset form
            navigate('/agent')
          } else {
            setMessage(`Error: ${response.data?.head?.msg || "Unexpected response format"}`);
            alert(response.data?.head?.msg);
          }
        } catch (error) {
          console.error("API Error:", error);
          setMessage("API Error: Unable to add agent.");
        } finally {
          setLoading(false);
        }
      };
      
  return (
    <>      
      <Header />
      <div class="page-wrapper compact-wrapper" id="pageWrapper">
        <div class="page-body-wrapper">
          <div class="page-body">
          <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-sm-12 m-auto">
                                    <div class="card">
                                        <div class="card-body">
                                      <div class="title-header option-title d-sm-flex d-block">
                                        <h5>Add Agent</h5>
                                        <div class="right-options">
                                            <ul>                                               
                                                <li>
                                                    <Link class="btn btn-solid" to="/agent">Back</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
      
                                    <form className="theme-form theme-form-2 mega-form" onSubmit={handleSubmit}>
                                            {/* Select Category Type */}
                                            {/* <div className="mb-4 row align-items-center">
                                                <label className="form-label-title col-sm-3 mb-0">Type of Category</label>
                                                <div className="col-sm-9">
                                                <select
                                                    className="js-example-basic-single w-100 form-control"
                                                    name="type_of_category"
                                                    value={formData.type_of_category}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select Type</option>
                                                    <option value="Home Appliances">Home Appliances</option>
                                                    <option value="Kitchen Appliances">Kitchen Appliances</option>
                                                    <option value="Accessories">Accessories</option>
                                                    <option value="Electronics">Electronics</option>
                                                </select>
                                                </div>
                                            </div> */}

                                            {/* Category Name Input */}
                                            <div className="mb-4 row align-items-center">
                                                <label className="form-label-title col-sm-3 mb-0">Agent Name</label>
                                                <div className="col-sm-9">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="agent_name"
                                                    value={formData.agent_name}
                                                    onChange={handleChange}
                                                    placeholder="Enter Agent Name"
                                                    required
                                                />
                                                </div>
                                            </div>

                                            {/* File Upload (if needed in the future) */}
                                            {/* <div className="mb-4 row align-items-center">
                                                <label className="form-label-title col-sm-3 mb-0">Upload Image</label>
                                                <div className="col-sm-9">
                                                <input className="form-control form-choose" type="file" id="formFile" multiple />
                                                </div>
                                            </div> */}

                                            {/* Submit & Cancel Buttons */}
                                            <div className="card-footer border-0 pb-0 d-flex justify-content-end">
                                                <button className="btn btn-primary me-3" type="submit" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                                </button>
                                                <button className="btn btn-outline" type="button"onClick={() => window.history.back()}>
                                                Cancel
                                                </button>
                                            </div>

                                            {/* Success/Error Message */}
                                            {/* {message && <p className="text-center mt-3">{message}</p>} */}
                                            </form>
                                    </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </>
  );
};

export default AddAgent;
